import axios from 'axios';
import { buildSalespersonSlugFromName, normalizeSalespersonSlug } from '../../utils/salespersonSlug';
const backendURL = "https://cms-booking-metropool.purplepanda.be";
// const backendURL = "https://metropoolbooking.pandas-agency.be";
const namespace = "/wp-json/pp-json";
const url = backendURL + namespace;
let cancelToken;

const get = async (uri)=>{
	const res = await axios.get(`${url}/${uri}`);
	return res.data;
}
const post = async (uri,data)=>{

	const res = await  axios.post(`${url}/${uri}`,JSON.stringify(data),{ cancelToken:cancelToken ? cancelToken.token : null,headers: { 'content-type': 'application/x-www-form-urlencoded' }});
	return res.data;
}

export const getBrands = async ()=>{
return get("getBrands")
}

export const getCarsByBrand = async (brandName,brandCondition)=>{
	const encodedBrand = encodeURIComponent(brandName);
	const encodedCondition = encodeURIComponent(brandCondition);
	return get(`getCars/${encodedBrand}/${encodedCondition}`);
}

export const getSalesEmployeeByBrand = async(brandLocationName,dateParam= null,brandCondition)=>{
let	queryParam = "";
	if(dateParam != null){
		queryParam=`?date=${dateParam}`
	}
	//Check if there are any previous pending requests
	if (typeof cancelToken != typeof undefined) {
		cancelToken.cancel("Operation canceled due to new request.");
	}
	cancelToken = axios.CancelToken.source();
	const encodedLocation = encodeURIComponent(brandLocationName);
	const encodedCondition = encodeURIComponent(brandCondition);
	return (await axios.get(`${url}/getSalesEmployeesByLocation/${encodedLocation}/${encodedCondition}${queryParam}`,{cancelToken:cancelToken.token})).data;
}

export const sendEmail = async (formData)=>{
	return post(`sendEmails`,formData);
}

export const checkEmployeeAppointment = async (formData)=>{
	return post(`isEmployeeBusy`,formData)
}
export const getCarByCarName = async (carName)=>{
	return get(`getCarByCarName/${carName}`);
}
export const getFooterData = async (brandName)=>{
	return get(`getFooterData/${brandName}`);
}
export const getNextAvailableTime = async(email,date)=>{
	return get(`getNextAvailableTime/${email}?date=${date}`)
}

const mapSalesEmployeeMeta = (employee) => {
	if (!employee || !employee.acf) return null;

	const locations = Array.isArray(employee.acf.locations)
		? employee.acf.locations
			.map((location) => location && location.post_name)
			.filter(Boolean)
		: [];
	const appointmentTypes = Array.isArray(employee.acf.appointment_types)
		? employee.acf.appointment_types.map((type) => String(type).toLowerCase())
		: [];

	return {
		slug: employee.slug,
		name: employee.acf.name || '',
		locations,
		appointmentTypes,
	};
};

const fetchAllSalesEmployees = async () => {
	const perPage = 100;
	const res = await axios.get(`${backendURL}/wp-json/wp/v2/salesemployee`, {
		params: {
			per_page: perPage,
			_fields: 'slug,acf',
		},
	});
	return Array.isArray(res.data) ? res.data : [];
};

export const getSalesEmployeeBySlug = async (slug) => {
	const normalizedSlug = normalizeSalespersonSlug(slug);
	if (!normalizedSlug) return null;

	const res = await axios.get(`${backendURL}/wp-json/wp/v2/salesemployee`, {
		params: {
			slug: normalizedSlug,
			_fields: 'slug,acf',
		},
	});
	let employee = Array.isArray(res.data) && res.data.length > 0 ? res.data[0] : null;

	if (!employee) {
		const allEmployees = await fetchAllSalesEmployees();
		employee = allEmployees.find((candidate) => {
			const candidateSlug = typeof candidate.slug === 'string' ? candidate.slug.toLowerCase() : '';
			const nameSlug = buildSalespersonSlugFromName(candidate.acf && candidate.acf.name);
			return candidateSlug === normalizedSlug || nameSlug === normalizedSlug;
		});
	}

	return mapSalesEmployeeMeta(employee);
}

// Fetch all WP posts from the ACF REST endpoint and return raw objects.
// Expected response shape example:
//   [{ "id": 523, "acf": { ... } }, ...]
export const getCarsFromACF = async ()=>{
	const perPage = 100;
	let page = 1;
	let totalPages = 1;
	const allCars = [];

	while (page <= totalPages) {
		const res = await axios.get(`${backendURL}/wp-json/acf/v3/cars?per_page=${perPage}&page=${page}`);
		const batch = Array.isArray(res.data) ? res.data : [];
		allCars.push(...batch);

		const headerTotalPages = Number(res.headers && res.headers['x-wp-totalpages']);
		totalPages = Number.isFinite(headerTotalPages) && headerTotalPages > 0 ? headerTotalPages : 1;
		page += 1;
	}

	return allCars;
}

const stripHtml = (value) => {
	if (value == null) return '';
	return String(value).replace(/<[^>]*>/g, '');
};

// Fetch car titles (+ state/brand taxonomy) for car IDs via WP REST v2.
// Returns: [{ id: number, name: string, states: string[], brands: string[] }, ...]
export const getCarTitlesFromWPV2ByIds = async (ids) => {
	if (!Array.isArray(ids) || ids.length === 0) return [];

	const uniqueIds = Array.from(new Set(ids)).filter((id) => id != null);
	const chunkSize = 50;
	const chunks = [];
	for (let i = 0; i < uniqueIds.length; i += chunkSize) {
		chunks.push(uniqueIds.slice(i, i + chunkSize));
	}

	const all = [];
	for (const chunk of chunks) {
		const res = await axios.get(
			`${backendURL}/wp-json/wp/v2/cars?include=${chunk.join(',')}&per_page=${chunk.length}&_fields=id,title,class_list`
		);
		all.push(...(Array.isArray(res.data) ? res.data : []));
	}

	return all
		.map((car) => ({
			id: car && car.id != null ? car.id : null,
			name: stripHtml(car && car.title && car.title.rendered ? car.title.rendered : ''),
			states: Array.isArray(car?.class_list)
				? car.class_list
					.filter((t) => typeof t === 'string' && t.startsWith('state-'))
					.map((t) => t.replace('state-', ''))
				: [],
			brands: Array.isArray(car?.class_list)
				? car.class_list
					.filter((t) => typeof t === 'string' && t.startsWith('brand-'))
					.map((t) => t.replace('brand-', ''))
				: [],
		}))
		.filter((car) => car.id != null && car.name);
};
